import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { UpdateProductTabProps } from '../../../../interfaces/Product/UpdateProductTab';
import { Product } from '../../../../interfaces/Product/Product';
import { getProduct } from '../../../../api/Product';
import { sharedStyles } from '../../../../utils/Style';
import { UpdateProductSlug } from './UpdateProductSlug';
import { Waiting } from '../../../../components/Waiting/Waiting';
import { MetaCard } from '../../../../components/Meta/MetaCard';
import { MetaTable } from '../../../../interfaces/Meta/MetaTable';
import { OpenInFrontend } from '../../../../components/OpenInFrontend/OpenInFrontend';

export const UpdateProductSEO = (props: UpdateProductTabProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState<Product | undefined>(undefined);

  const refreshProduct = () => {
    setLoading(true);
    getProduct(props.productID)
      .then((p) => setProduct(p))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshProduct();
  }, []);

  const goBack = () => navigate(`/products/catalog${location.search}`);

  return (
    <Box sx={{ ...sharedStyles.pageBody, p: 3 }}>
      <Waiting open={loading} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 3,
          gap: 1.5,
        }}
      >
        <IconButton onClick={goBack} sx={{ ...sharedStyles.backIcon }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>SEO</Typography>

        <Box sx={{ flexGrow: 1 }} />

        {!!product && (
          <OpenInFrontend
            path='urun'
            slug={product.slug}
            isActive={product.isActive}
          />
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 1.5,
          minWidth: 0,
        }}
      >
        <MetaCard table={MetaTable.PRODUCT} id={props.productID} />

        <UpdateProductSlug initialValue={product} onSave={refreshProduct} />
      </Box>
    </Box>
  );
};
